// extracted by mini-css-extract-plugin
export default {"container":"ZaptranceLogo_container__qcGm3"};